import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import Avatar from './Avatar'
import Skeleton from './Skeleton'
import { getInitials } from '../modules'
import {
  getUserAvatar,
  getUserName,
} from '../modules/authentication'

function UserProfile() {
  const userName = useSelector(getUserName)
  const userAvatar = useSelector(getUserAvatar)

  return (
    <div className="flex">
      <Link to="/sign-out" className="group flex-shrink-0 block">
        <div className="flex items-center">
          <Avatar
            image={userAvatar}
            alt={userName ? getInitials(userName).join('') : ''}
          />
          <div className="ml-3">
            {userName ? (
              <p className="text-base font-medium text-gray-700 group-hover:text-gray-900">
                {userName}
              </p>
            ) : <Skeleton />}
            <div className="text-gray-500 group-hover:text-gray-700">
              Sign out
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default UserProfile
